module.exports = __webpack_public_path__ + "img/su-icon-up.44388787.svg";